import { createContext, useContext } from 'react';
import type { SupportMessagesService } from '../../platform/supabase/support-messages-data';

// Provided once in App so every screen's shell can offer the same in-app
// "Help and support" box without threading a provider through each screen.
// Absent (e.g. isolated tests), the shell falls back to a plain mailto link.
export const SupportMessageContext =
  createContext<SupportMessagesService | null>(null);

export function useSupportMessages() {
  return useContext(SupportMessageContext);
}
